// extracted by mini-css-extract-plugin
module.exports = {"scroll":"ScrollButton_scroll__HUM_p","line":"ScrollButton_line__0xEW8","arrowsDown":"ScrollButton_arrowsDown__RIAro","arrowsDownSmall":"ScrollButton_arrowsDownSmall___9yBl"};